import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { WizardNavigationComponent } from '../../../../shared/components/wizard-navigation/wizard-navigation.component';
import { CheckboxComponent, RadioComponent, TextInputComponent } from 'ddmo-storybook-lib';
import { SharedService } from '../../../../shared/services/shared.service';
import { LoaderService } from '../../../../shared/services/loader.service';

const SIGNATURE_MAX_LENGTH = 100;
@Component({
    selector: 'app-attestations',
    imports: [CommonModule, ReactiveFormsModule, WizardNavigationComponent,RadioComponent,TextInputComponent,CheckboxComponent],
    templateUrl: './attestations.component.html',
    styleUrl: './attestations.component.scss'
})
export class AttestationsComponent implements OnInit {
  questionsForm!: FormGroup;
  AttestationcheckForm!: FormGroup;
  fullnameGroup!: FormGroup;
  messageGroup!: FormGroup;
  confirmationCheckbox = false
  formValid = false
  FullName = ''
  formatted = ''
  attestationQuestionsData:any = {}
  attesatationResponseData:any = {}
  attesatationData:any = {}
  action:any = ''
  isupdate:any
  isRecred : any
  questionsConfig:any = [];
  checkboxLabel =
    'I hereby certify that all information provided is true and correct';
    constructor(private fb: FormBuilder, private router: Router,private shared:SharedService,private loader:LoaderService,) {
    }
    errorMessage = ""
    impersonatedUser:any = localStorage.getItem("impersonatedUser") ?? ""

    ngOnInit(): void {
    window.scrollTo({top: 0, behavior: 'smooth' });
    this.loader.show()
    let AllAttestationQuestions = localStorage.getItem("AllAttestationQuestions")
    if(AllAttestationQuestions){
      this.questionsConfig = JSON.parse(AllAttestationQuestions);
      this.getAllValues()
    }else{
    this.getAllAttestationQuestions()
    }

    }
    getAllValues(){
      this.initForms();
      this.buildQuestions();
      this.setupConditionalExplanationValidation();
      this.enableCheckboxAfterQuestions();
      this.enableFullNameAfterCheckbox();
      this.generateAttestation();
      let attestationQuestions = localStorage.getItem('attestationQuestions')
      this.attestationQuestionsData = attestationQuestions ? JSON.parse(attestationQuestions) : null;
      let attestationResponses = localStorage.getItem('attestationResponses') 
      this.attesatationResponseData = attestationResponses ? JSON.parse(attestationResponses) : null;
      let attesatationData = localStorage.getItem('attestation') 
      this.attesatationData = attesatationData ? JSON.parse(attesatationData) : {};
      this.action =localStorage.getItem('Action') ? localStorage.getItem('Action') : ""
      this.isRecred = this.action =='Recred'?true:false;
      if (this.attesatationResponseData && (this.action == 'Recred' || this.action == 'Draft' || this.action == 'Edit' || (this.attesatationData &&this.attesatationData['attestationId']))) {
        this.bindForm();
      }
      this.loader.hide()
      if(this.impersonatedUser){
        this.makeFormsReadOnly();
      }
    }

    onBack() {
        this.saveAttesatations(false)
    }

    onNext() {
        if (this.formValid) {
            this.router.navigate(['/credentialing/locations']);
        }
        this.saveAttesatations(true)
    }
  initForms() {
    this.questionsForm = this.fb.group({
      questions: this.fb.array([])
    });

    this.AttestationcheckForm = this.fb.group({
      Attestation: [{ value: false, disabled: true }, Validators.requiredTrue]
    });

    this.fullnameGroup = this.fb.group({
      fullName: [{ value: '', disabled: true }, [Validators.required, Validators.max(200)]]
    });

    this.messageGroup = this.fb.group({
      message: [{value:'',disabled : true}]
    });
  }
  get questions(): FormArray {
    return this.questionsForm.get('questions') as FormArray;
  }
  getQuestionGroup(index: number): FormGroup {
    return this.questions.at(index) as FormGroup;
  }
  get fullNameControl(): FormControl {
    return this.fullnameGroup.get('fullName') as FormControl;
  }

  buildQuestions() {
    this.questionsConfig.forEach((text:any,index:any) => {
      this.questions.push(
        this.fb.group({
          response: [null, Validators.required],
          explanation: [''],
          attestationQuestionId: index + 1
        })
      );
    });
  }

  getExplanationControl(index: number): FormControl {
    return this.questions.at(index).get('explanation') as FormControl;
  }

  setupConditionalExplanationValidation() {
    this.questions.controls.forEach((questionGroup: any) => {
      const answerCtrl = questionGroup.get('response');
      const explanationCtrl = questionGroup.get('explanation');   
      answerCtrl.valueChanges.subscribe((value: string) => {
        if (value === 'yes') {
          explanationCtrl.setValidators([Validators.required,this.shared.noWhitespaceValidator()]);
        } else {
          explanationCtrl.clearValidators();
          explanationCtrl.reset();
        }
   
        explanationCtrl.updateValueAndValidity({ emitEvent: false });
      });
    });
  }
  enableCheckboxAfterQuestions() {
    this.questionsForm.valueChanges.subscribe(() => {
      if (this.questionsForm.valid) {
        this.AttestationcheckForm.get('Attestation')?.enable();
      } else {
        this.AttestationcheckForm.patchValue({
            'Attestation' : false
        })
        this.fullnameGroup.patchValue({
          'fullName' : ""
        })
        this.messageGroup.patchValue({
          message:
  `Attested by: ${""}\n\nAttested on: ${""}`
        });
        this.AttestationcheckForm.get('Attestation')?.disable();
        this.fullnameGroup.get('fullName')?.disable();
        this.messageGroup.reset();
      }
    });
  }
  enableFullNameAfterCheckbox() {
    this.AttestationcheckForm.get('Attestation')?.valueChanges.subscribe(
      checked => {
        if (checked) {
          this.confirmationCheckbox = false
          const fullName: any = this.resolveExpectedProviderSignatureName();
          this.fullnameGroup?.get('fullName')?.setValue(fullName);
          this.AttestationcheckForm?.get('Attestation')?.markAsTouched()
          this.fullnameGroup.get('fullName')?.disable();
          this.fullnameGroup.get('fullName')?.setValidators([Validators.required,this.shared.noWhitespaceValidator()]);
        } else {
          this.fullnameGroup.get('fullName')?.markAsUntouched()
          if(this.questionsForm.valid && this.AttestationcheckForm.get('Attestation')?.touched){
          this.confirmationCheckbox = true
          this.fullnameGroup.patchValue({
            'fullName' : ""
          })
          this.messageGroup.patchValue({
            message:
    `Attested by: ${""}\n\nAttested on: ${""}`
          });
        this.FullName = ""
        this.formatted = ""
          }
          this.fullnameGroup.get('fullName')?.disable();
          this.messageGroup.reset();
        }
      }
    );
  }
  generateAttestation() {
    this.fullnameGroup.get('fullName')?.valueChanges.subscribe(name => {
      if (!name || name.trim()==""){ 
        this.messageGroup.patchValue({
          message:
  `Attested by: ${""}\n\nAttested on: ${""}`
        });
        this.FullName = ""
        this.formatted = ""
        return;
      }

      const now = new Date();
      this.FullName = name
      this.formatted = now.toLocaleString('en-US', {
        timeZone: 'UTC',
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      });

      this.messageGroup.patchValue({
        message:
`Attested by: ${name}\n\nAttested on: ${name ? this.formatted : ""}`
      });
    });
  }
  saveAttesatations(isForward?:any){
    this.loader.show()
    if((this.attesatationData && this.attesatationData['attestationId']) || (this.action == 'Recred' || this.action == 'Draft' || this.action == 'Edit')){
      this.isupdate = true
    }
    const credentialEventId = localStorage.getItem('credentialingEventId')
    const questionFormvalues = this.questionsForm.value.questions
    const updatedResponses = questionFormvalues.map((item: any) => ({
      ...item,
      response:
        item.response === null
          ? null
          : item.response === 'yes'
    }));
    if(this.AttestationcheckForm.get('Attestation')?.value == false){
    this.attesatationData['attestedBy'] = ""
    this.attesatationData['attestedOn'] = null
    }
    this.attesatationData['attestedBy'] = this.FullName
    this.attesatationData['attestedOn'] = this.formatted
    this.attesatationData['attestedAckCertify'] = this.AttestationcheckForm.get('Attestation')?.value
    let createPayload = { 
      "attestationId": this.isupdate ? this.attesatationData['attestationId'] : null,
      "credentialingEventId": credentialEventId ? credentialEventId :null,
      "attestedBy": this.FullName && this.AttestationcheckForm.get('Attestation')?.value  ? this.FullName :"",
      "attestedOn": this.formatted && this.AttestationcheckForm.get('Attestation')?.value  ? this.formatted : null,
      "userId": localStorage.getItem("loggedUserId") ? localStorage.getItem("loggedUserId") : null , 
      "attestedAckCertify":this.AttestationcheckForm.get('Attestation')?.value, 
      "responses" : updatedResponses
     }
     this.shared.saveAttestation(createPayload).subscribe({
      next: (res: any) => {
        localStorage.setItem('attestationResponses', JSON.stringify(updatedResponses));
        if (!this.attesatationData['attestationId']) {
          this.attesatationData['attestationId'] = res['attestationId'];
        }
        localStorage.setItem('attestation', JSON.stringify(this.attesatationData));
        this.loader.hide();
        if (isForward) {
          this.router.navigate(['/credentialing/locations']);
        } else {
          this.router.navigate(['/credentialing/work-history']);
        }
      },
      error: (err) => {
        this.loader.hide();
        this.shared.logError("APIFailed", "FileAttestationsComponent - saveAttestation, Method:saveAttestations", this.router.url.split('?')[0], err).subscribe();
      }
    });
  }
  bindForm() {

    const updatedResponses = Object.values(this.attesatationResponseData).map(
  
      (item: any) => ({
  
        ...item,
  
        response:
  
          item.response === null
  
            ? null
  
            : item.response === true
  
              ? 'yes'
  
              : 'no'
  
      })
  
    );
   
    this.questionsForm.patchValue({
  
      questions: updatedResponses
  
    });
   
    const allQuestionsValid = this.questionsForm.valid;
   
    this.AttestationcheckForm.patchValue({
  
      Attestation: this.attesatationData['attestedAckCertify']
  
    });
   
    this.fullnameGroup.patchValue({
  
      fullName: this.attesatationData['attestedAckCertify'] ? this.attesatationData?.['attestedBy'] || '' : ""
  
    });
   
    this.messageGroup.patchValue({
  
      message: this.attesatationData['attestedAckCertify'] ? `Attested by: ${this.attesatationData?.['attestedBy'] || ''}\n\nAttested on: ${this.attesatationData?.['attestedOn'] ? this.attesatationData?.['attestedOn'] : ""}` : ""
  
    });
  }
  get checkFormIsvalid(){
    return this.questionsForm.valid && this.AttestationcheckForm.valid && this.fullnameGroup.valid;
  }
  onCancel(){
    this.router.navigate(['/landing']);
  }
  getAllAttestationQuestions() {
    this.shared.getAttestationQuestions().subscribe({  
      next: (response: any) => {   
        this.questionsConfig = response['questions'];  
        localStorage.setItem("AllAttestationQuestions", JSON.stringify(response['questions']));    
        this.getAllValues();  
      },  
      error: (err) => {   
        this.shared.logError("APIFailed", "FileAttestationsComponent - getAttestationQuestions, Method:getAllAttestationQuestions", this.router.url.split('?')[0], err).subscribe(); 
        this.handleLoadingError(err);  
      },
  
      complete: () => {
       this.loader.hide()  
      }  
    });  
  }   
  private handleLoadingError(error: any) {
    this.errorMessage = "Failed to load questions. Please try again later."; 
  }  
  makeFormsReadOnly(){
    this.questionsForm.disable();
    this.fullnameGroup.disable();
    this.AttestationcheckForm.get('Attestation')?.disable();
  } 

  private resolveExpectedProviderSignatureName(): string {
    const demographics = JSON.parse(localStorage.getItem('demographics') || '{}');
    const loggedUserDetails = JSON.parse(localStorage.getItem('loggedUserDetails') || '{}');
    const demographicLastName = demographics?.lastName || '';
    const demographicFullName = `${demographics?.firstName || ''} ${demographicLastName}`.trim();

    if (demographicFullName) {
      return demographicFullName.slice(0, SIGNATURE_MAX_LENGTH);
    }

    return `${loggedUserDetails?.firstName || ''} ${loggedUserDetails?.lastName || ''}`
      .trim()
      .slice(0, SIGNATURE_MAX_LENGTH);
  }
}
